import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const $FooterContainer = styled.div`
  background: #101522;
`;

export const $FooterWrappper = styled.div`
  padding: 48px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1100px;
  margin: 0 auto;
`;

export const $FooterLinksContainer = styled.div`
  display: flex;
  justify-content: center;

  @media (max-width: 820px) {
    padding: 32px;
  }
`;

export const $FooterLinksWrapper = styled.div`
  display: flex;

  @media (max-width: 820px) {
    flex-direction: column;
  }
`;

export const $FooterLinksItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 16px;
  text-align: left;
  width: 160px;
  box-sizing: border-box;
  color: #f5f5f5;

  @media (max-width: 420px) {
    margin: 0;
    padding: 10px;
    width: 100%;
  }
`;

export const $FooterLinkTitle = styled.h3`
  font-size: 14px;
  margin-bottom: 16px;
`;

export const $FooterLink = styled(Link)`
  color: #f5f5f5;
  text-decoration: none;
  margin-bottom: 0.5rem;
  font-size: 14px;

  &:hover {
    color: #4a919b;
    transition: 0.3 ease-out;
  }
`;

export const $SocialMedia = styled.div`
  max-width: 100%;
  width: 100%;
`;

export const $SocialMediaWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1100px;
  margin: 40px auto 0 auto;

  @media (max-width: 820px) {
    flex-direction: column;
  }
`;

export const $WebsiteRights = styled.p`
  color: #fff;
  margin-bottom: 16px;
`;

export const $SocialIcons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 240px;
`;

export const $SocialLogo = styled(Link)`
  color: #8ea09e;
  justify-self: start;
  cursor: pointer;
  text-decoration: none;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-weight: bold;
`;

export const $SocialIconLink = styled.a`
  color: #fff;
  font-size: 24px;
`;
